var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(`height: ${_vm.height}px;`),attrs:{"src":`/goguest-logo.png`}})
}
var staticRenderFns = []

export { render, staticRenderFns }